import React, { useState, useEffect } from 'react';
import { Search, Download } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

export default function DireccionLicencias() {
    const [licencias, setLicencias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [gestion, setGestion] = useState(new Date().getFullYear());

    useEffect(() => { loadLicencias(); }, [gestion]);

    const loadLicencias = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_URL}/direccion/autorizaciones/licencias?gestion=${gestion}`);
            const data = await response.json();
            setLicencias(data.licencias || []);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEstadoChange = async (id, estado) => {
        try {
            await fetch(`${API_URL}/direccion/autorizaciones/licencias/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ estado })
            });
            loadLicencias();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const filtered = licencias.filter(l =>
        searchTerm === '' || `${l.nombre} ${l.apellido}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <div className="p-6 text-center">Cargando...</div>;

    return (
        <div className="p-4 md:p-6 max-w-full mx-auto">
            <div className="mb-6">
                <h1 className="text-xl font-bold text-gray-800">Dirección Académica &gt; Autorizaciones &gt; Solicitud Permisos</h1>
            </div>
            <div className="mb-6 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                <div className="flex flex-wrap items-center gap-4">
                    {/* BUSCAR Y EXCEL */}
                    <div className="flex-grow flex items-center gap-2">
                        <div className="relative flex-grow">
                            <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1">BUSCAR</label>
                            <div className="relative">
                                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                                <input
                                    type="text"
                                    placeholder="Buscar..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full h-[38px] pl-10 pr-4 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 hover:border-blue-500"
                                />
                            </div>
                        </div>
                    </div>
                    {/* GESTIÓN */}
                    <div className="relative">
                        <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1">GESTIÓN</label>
                        <div className="relative">
                            <select
                                value={gestion} onChange={(e) => setGestion(parseInt(e.target.value))}
                                className="h-[38px] px-4 border border-gray-300 rounded-full bg-white text-sm appearance-none pr-8 hover:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 min-w-[100px]"
                            >
                                {[2024, 2025, 2026, 2027].map(g => (
                                    <option key={g} value={g}>Gestión {g}</option>
                                ))}
                            </select>
                            <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 text-xs">▼</span>
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-transparent mb-1 ml-1 select-none">ACCION</label>
                        <button
                            onClick={() => {
                                const headers = ['No', 'Docente', 'Asignatura', 'Tipo Permiso', 'Fecha Permiso', 'Hora Permiso', 'Reemplazo/Compensación', 'Hora Reemplazo/Compensación', 'Docente Reemplazo', 'Sala Compensación', 'Estado'];
                                const rows = filtered.map((l, i) => [
                                    i + 1,
                                    `${l.nombre || ''} ${l.apellido || ''}`,
                                    l.asignatura || '',
                                    l.tipo_licencia || l.tipo_permiso || '',
                                    l.fecha_inicio ? new Date(l.fecha_inicio).toLocaleDateString() : '',
                                    l.hora_inicio || '',
                                    l.fecha_reemplazo ? new Date(l.fecha_reemplazo).toLocaleDateString() : '',
                                    l.hora_reemplazo || '',
                                    l.docente_reemplazo_nombre || '',
                                    l.sala_compensacion || '',
                                    l.estado || ''
                                ]);
                                const csv = [headers.join(','), ...rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(','))].join('\n');
                                const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = `licencias_docentes_${new Date().toISOString().split('T')[0]}.csv`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(link.href);
                            }}
                            className="p-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition shadow-sm" title="Descargar Excel"
                        >
                            <Download size={20} />
                        </button>
                    </div>

                </div>
            </div>
            {/* Barra de búsqueda */}
            {/* <div className="mb-4 flex gap-3 items-center">
                <select value={gestion} onChange={(e) => setGestion(parseInt(e.target.value))} className="px-4 py-2 border border-gray-300 rounded-full bg-white">
                    {[2024, 2025, 2026, 2027].map(g => (
                        <option key={g} value={g}>Gestión {g}</option>
                    ))}
                </select>
                <div className="flex-1 max-w-md relative">
                    <input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-full"
                    />
                    <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                </div>
                <button
                    onClick={() => {
                        const headers = ['No', 'Docente', 'Asignatura', 'Tipo Permiso', 'Fecha Permiso', 'Hora Permiso', 'Reemplazo/Compensación', 'Hora Reemplazo/Compensación', 'Docente Reemplazo', 'Sala Compensación', 'Estado'];
                        const rows = filtered.map((l, i) => [
                            i + 1,
                            `${l.nombre || ''} ${l.apellido || ''}`,
                            l.asignatura || '',
                            l.tipo_licencia || l.tipo_permiso || '',
                            l.fecha_inicio ? new Date(l.fecha_inicio).toLocaleDateString() : '',
                            l.hora_inicio || '',
                            l.fecha_reemplazo ? new Date(l.fecha_reemplazo).toLocaleDateString() : '',
                            l.hora_reemplazo || '',
                            l.docente_reemplazo_nombre || '',
                            l.sala_compensacion || '',
                            l.estado || ''
                        ]);
                        const csv = [headers.join(','), ...rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(','))].join('\n');
                        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `licencias_docentes_${new Date().toISOString().split('T')[0]}.csv`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(link.href);
                    }}
                    className="p-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition shadow-sm" title="Descargar Excel"
                >
                    <Download size={20} />
                </button>
            </div> */}

            {/* Tabla de Licencias */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-2 py-3 text-center font-semibold border">No</th>
                                <th className="px-2 py-3 text-center font-semibold border">Docente</th>
                                <th className="px-2 py-3 text-center font-semibold border">Asignatura</th>
                                <th className="px-2 py-3 text-center font-semibold border">Tipo Permiso</th>
                                <th className="px-2 py-3 text-center font-semibold border">Fecha Permiso</th>
                                <th className="px-2 py-3 text-center font-semibold border">Hora Permiso</th>
                                <th className="px-2 py-3 text-center font-semibold border">Reemplazo/ Compensación</th>
                                <th className="px-2 py-3 text-center font-semibold border">Hora Reemplazo/ Compensación</th>
                                <th className="px-2 py-3 text-center font-semibold border">Docente Reemplazo</th>
                                <th className="px-2 py-3 text-center font-semibold border">Sala Compensación</th>
                                <th className="px-2 py-3 text-center font-semibold border">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr><td colSpan="11" className="px-4 py-8 text-center text-gray-500 border">No hay licencias pre-aprobadas</td></tr>
                            ) : (
                                filtered.map((l, index) => (
                                    <tr key={l.id_licencia} className="hover:bg-gray-50">
                                        <td className="px-2 py-2 text-center border">{index + 1}</td>
                                        <td className="px-2 py-2 text-center border">{l.nombre} {l.apellido}</td>
                                        <td className="px-2 py-2 text-center border">{l.asignatura || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{l.tipo_licencia || l.tipo_permiso || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{l.fecha_inicio ? new Date(l.fecha_inicio).toLocaleDateString() : '-'}</td>
                                        <td className="px-2 py-2 text-center border">{l.hora_inicio || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{l.fecha_reemplazo ? new Date(l.fecha_reemplazo).toLocaleDateString() : '-'}</td>
                                        <td className="px-2 py-2 text-center border">{l.hora_reemplazo || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{l.docente_reemplazo_nombre || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{l.sala_compensacion || '-'}</td>
                                        <td className="px-2 py-2 text-center border">
                                            <select
                                                value={l.estado || 'preaprobado'}
                                                onChange={(e) => handleEstadoChange(l.id_licencia, e.target.value)}
                                                className={`px-2 py-1 rounded text-xs font-medium border-0 ${l.estado === 'aprobado_direccion' ? 'bg-green-100 text-green-800' :
                                                    l.estado === 'rechazado_direccion' ? 'bg-red-100 text-red-800' :
                                                        'bg-yellow-100 text-yellow-800'
                                                    }`}
                                            >
                                                <option value="preaprobado">Pendiente</option>
                                                <option value="aprobado_direccion">Aprobar</option>
                                                <option value="rechazado_direccion">Rechazar</option>
                                            </select>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
